<template>
    <div id="setting-screen" class="mt-0">
        <v-tabs :value="currentTabIndex" @change="changeTab" background-color="transparent" class="bg-white mb-4 rounded">
            <v-tab v-for="tabItem in tabs" :tabindex="tabItem.index" :key="tabItem.index"
                @click="loadRoute(tabItem.routeName)">{{ tabItem.label }}</v-tab>
        </v-tabs>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            currentTabIndex: null,
            tabs: [
                {
                    index: 0,
                    label: this.$t("_ROLES.BOOKING_ENGINE_CONFIG"),
                    routeName: "schedule",
                    roles: ['RMS_MANAGEMENT']
                },
                {
                    index: 1,
                    label: this.$t("DYNAMIC_PRICING"),
                    routeName: "dynammic-pricing-list",
                    roles: ['DYNAMIC_PRICING']
                },
                {
                    index: 2,
                    label: this.$t("DYNAMIC_RESTRICTION"),
                    routeName: "dynammic-restriction-list",
                    roles: ['DYNAMIC_RESTRICTION']
                }
            ]
        };
    },
    created() {
        this.tabs = this.fnItemTab(this.tabs);
        switch (this.$route.name) {
            case "schedule":
                this.currentTabIndex = 0;
                break;
            case "dynammic-pricing-detail":
            case "dynammic-pricing-list":
                this.currentTabIndex = 1;
                break;
            case "dynammic-restriction-detail":
            case "dynammic-restriction-list":
                this.currentTabIndex = 2;
                break;
        }
    },
    watch: {
        $route(value) {
            switch (this.$route.name) {
                case "schedule":
                    this.currentTabIndex = 0;
                    break;
                case "dynammic-pricing-detail":
                case "dynammic-pricing-list":
                    this.currentTabIndex = 1;
                    break;
                case "dynammic-restriction-detail":
                case "dynammic-restriction-list":
                    this.currentTabIndex = 2;
                    break;
            }
        },
    },
    methods: {
        changeTab(tabIndex) {
            this.currentTabIndex = tabIndex;
        },
        loadRoute(routeName) {
            this.$router.push({ name: routeName });
        }
    }
};
</script>
